import * as system from 'durandal/system';

import * as companyService from '@/legacy/services/company';
import { SessionTimeoutService } from '@/legacy/services/sessionTimeout';
import * as userService from '@/legacy/services/user';
import * as plootoUtils from '@/legacy/utils/plooto';

import type { FileStorageDownloadLinkViewModel } from '../types/FileStorageDownloadLinkViewModel';

const API_PREFIX = 'v1';

export class CompanyFileStorageService {
  public generateDownloadFileAttachmentLink(companyFileStorageFileId: string) {
    const companyId = companyService.Instance.CompanyId();
    return system
      .defer<FileStorageDownloadLinkViewModel>((dfd) => {
        userService.Instance.AuthorizedGet(
          `${
            import.meta.env.APP_URLS_API_URL
          }/${API_PREFIX}/companies/${companyId}/fileStorage/${companyFileStorageFileId}`
        )
          .then((data) => {
            if (plootoUtils.IsNullOrUndefined(data) || data.error === true) {
              // The only error that can occur during link generation is that the user is no longer logged in (or session token expired)
              if (data.type === 'invalid.authentication') {
                SessionTimeoutService.showTimeout();
              }

              dfd.reject(data);
              return;
            }

            dfd.resolve(data);
          })
          .fail((error) => console.error(error));
      })
      .promise();
  }
}

export const Instance = new CompanyFileStorageService();
